import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import styled from 'styled-components';
import { Section } from '../../Section';
import { Carousel, breakPointsSet4 } from '../../Carousel';
import { SkeletonSquare } from '../../Skeleton';
import { ProductCard } from './../../Products/List/GridView/ProductCard';
export var SkeletonCard = styled.div.withConfig({
  displayName: "ProductsCarousel__SkeletonCard",
  componentId: "sc-1jwb7yq-0"
})(["height:226px;"]);
export var ProductsCarousel = function ProductsCarousel(_ref) {
  var products = _ref.products,
    subscriptions = _ref.subscriptions,
    onFollow = _ref.onFollow,
    title = _ref.title,
    subtitle = _ref.subtitle,
    link = _ref.link,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA;
  return React.createElement(Section, {
    title: title,
    subtitle: subtitle,
    link: link,
    bottomMargin: true,
    topMargin: true
  }, products.length ? React.createElement(Carousel, {
    breakpoints: breakPointsSet4
  }, products.map(function (product) {
    return React.createElement(ProductCard, {
      key: product.id,
      product: product,
      following: subscriptions.includes(product.id),
      onFollow: onFollow,
      withSPA: withSPA
    });
  })) : React.createElement(Carousel, {
    breakpoints: breakPointsSet4
  }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(function (placeholderId) {
    return React.createElement(SkeletonCard, {
      key: placeholderId
    }, React.createElement(SkeletonSquare, {
      style: {
        height: '100%'
      }
    }));
  })));
};